import React from "react";
import { CheckCircle, Home, RotateCcw } from "lucide-react";
import { useNavigate } from "react-router-dom";

const StepSuccess = ({ onReset }) => {
  const navigate = useNavigate();

  return (
    <div className="animate-in fade-in zoom-in duration-500 py-10 text-center flex flex-col items-center justify-center h-full">
      <div className="w-20 h-20 bg-green-100 dark:bg-green-900/30 rounded-full flex items-center justify-center mb-6">
        <CheckCircle className="w-10 h-10 text-green-600 dark:text-green-400" />
      </div>

      <h2 className="text-3xl font-bold text-slate-900 dark:text-white mb-2 font-serif">
        Booking Confirmed!
      </h2>
      <p className="text-slate-600 dark:text-slate-300 max-w-md mb-8">
        Your request has been successfully submitted. We have sent a
        confirmation email with all the details.
      </p>

      <div className="flex flex-col sm:flex-row gap-4">
        <button
          onClick={() => navigate("/")}
          className="px-6 py-3 rounded-lg border border-slate-300 dark:border-slate-600 text-slate-700 dark:text-slate-300 font-medium hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors flex items-center justify-center"
        >
          <Home className="w-4 h-4 mr-2" />
          Back to Home
        </button>

        <button
          onClick={onReset}
          className="px-6 py-3 rounded-lg bg-blue-600 hover:bg-blue-700 text-white font-bold shadow-lg hover:shadow-xl transition-all flex items-center justify-center"
        >
          <RotateCcw className="w-4 h-4 mr-2" />
          Book Another
        </button>
      </div>
    </div>
  );
};

export default StepSuccess;
